/**
 * Enum representing the different category ratings
 */
export enum RatingCategory {
    /**
     * The value is very high in comparison to others.
     */
    VERY_GOOD = 'very-good',

    /**
     * The value is good in comparison to others.
     */
    GOOD = 'good',

    /**
     * The value is satisfying in comparison to others.
     */
    SATISFYING = 'satisfying',

    /**
     * The value meets the required threshold.
     */
    SUFFICIENT = 'sufficient',

    /**
     * The value is below the required threshold.
     */
    FAILED = 'failed',

    /**
     * The value is completely below the required threshold.
     */
    COMPLETELY_FAILED = 'completely-failed'
}
